export default class ResponseErrors {
  public DisplayName: string[];
  constructor() {
    this.DisplayName = [] as string[];
  }
}
